{
  "home": "Главная",
  "games": "Игры",
  "casino": "Казино",
  "sports": "Спорт",
  "bonuses": "Бонусы",
  "wallet": "Касса",
  "menu": "Меню",
  "profile": "Кабинет",
  "login": "Вход",
  "loginSoon": "Вход — скоро"
}
